export default __webpack_public_path__ + "static/media/logo-white.3a678f5a.png";